module.exports = __webpack_public_path__ + "static/media/4.5a4ac2af.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row5/4.wav
// module id = 88
// module chunks = 0